import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector /* useStore */ } from 'react-redux';
import { useTranslation } from 'react-i18next';
// import { Modal } from 'antd';
// import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons';
import SearchableTable from '@components/SearchableTable';
// import IconButton from '@components/IconButton';
// import { waitForStoreUpdate } from '@utils';
import {
  /* deleteIndexEvents, */ switchIndexEventOrder,
  fetchIndexEvents,
} from '@pathways/redux/indexEvents/actions';
import {
  selectIndexEvents /* selectIndexEventDeleting */,
  selectIndexEventEditing,
  selectIndexEventsSwitching,
} from '@pathways/redux/indexEvents/reducers';
import createColumns from './createColumns';

const filterFunc = (value, comparator) => {
  return comparator(value.name);
};

function IndexEventsList() {
  const { i18n, t } = useTranslation();
  // const store = useStore();
  const dispatch = useDispatch();
  const [loading, indexEvents] = useSelector(selectIndexEvents);
  const indexEventsSwitching = useSelector(selectIndexEventsSwitching);
  const [sortedIndexEvents, setSortedIndexEvents] = useState([]);

  const editing = useSelector(selectIndexEventEditing);
  // const [selectedIndexEventIds, setSelectedIndexEventIds] = useState([]);
  const columns = useMemo(
    () =>
      createColumns(
        t,
        i18n.language,
        editedIndexEvent =>
          dispatch(switchIndexEventOrder(editedIndexEvent.id, editedIndexEvent.order)),
        {
          down: indexEvents[indexEvents.length - 1] && indexEvents[indexEvents.length - 1].id,
          up: indexEvents[0] && indexEvents[0].id,
        },
      ),
    [dispatch, t, i18n, indexEvents],
  );
  // const onRowSelectionChange = useCallback(
  //   selectedRows => setSelectedIndexEventIds(selectedRows),
  //   [],
  // );

  // const onDelete = useCallback(
  //   () =>
  //     Modal.confirm({
  //       title: t('indexEvents:List.delete.confirm'),
  //       onOk: () => {
  //         dispatch(deleteIndexEvents(selectedIndexEventIds));
  //         return waitForStoreUpdate(store, selectIndexEventDeleting);
  //       },
  //       onCancel: () => {},
  //     }),
  //   [dispatch, selectedIndexEventIds, store, t],
  // );

  useEffect(() => {
    dispatch(fetchIndexEvents());
  }, [dispatch]);

  useEffect(() => {
    if (!loading && !indexEventsSwitching && !editing && indexEvents?.length > 0)
      setSortedIndexEvents(indexEvents.sort((a, b) => a.order - b.order));
  }, [indexEvents, loading, editing, indexEventsSwitching]);

  return (
    <SearchableTable
      columns={columns}
      dataSource={sortedIndexEvents}
      // extra={
      //   <IconButton
      //     disabled={selectedIndexEventIds.length === 0}
      //     icon={faTrashAlt}
      //     tooltip={t('common:buttons.delete')}
      //     onClick={onDelete}
      //   />
      // }
      loading={editing || loading || indexEventsSwitching}
      filterFunc={filterFunc}
      // onRowSelectionChange={onRowSelectionChange}
    />
  );
}

export default IndexEventsList;
